import homeAPI from "./home";
import memberAPI from "./member";
import articleAPI from "./article";
export default {
  ...homeAPI,
  ...memberAPI,
  ...articleAPI
};